import { redactConsoleBreadcrumb } from '@forgd/logger/browser'

const REPLAYS_SESSION_SAMPLE_RATE = 0.1

export default defineNuxtPlugin(async (nuxtApp) => {
  if (!useRequestURL().host.includes('forgd.com')) {
    return
  }
  if (import.meta.dev) {
    return
  }
  const app = nuxtApp.vueApp
  const router = useRouter()
  const { sentry } = useRuntimeConfig().public
  const { analyticsConsent } = useCookieConsent()
  await import('@sentry/vue').then((Sentry) => {
    Sentry.init({
      ...sentry,
      app,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: [/^https:\/\/api\.forgd\.com/, /^https:\/\/dev-api\.forgd\.com/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
      replaysOnErrorSampleRate: 1.0,

      beforeBreadcrumb: redactConsoleBreadcrumb,
    })

    // Session replay records user activity — requires analytics consent.
    // Error monitoring itself is strictly necessary and always initialized above.
    watch(analyticsConsent, (consent) => {
      const replay = Sentry.getReplay()
      if (consent === 'granted') {
        if (!replay) {
          Sentry.addIntegration(Sentry.replayIntegration())
        }
        else if (Math.random() < REPLAYS_SESSION_SAMPLE_RATE) {
          // re-granted after a stop: the integration cannot be added twice, and
          // start() ignores sampling — roll the session rate manually before resuming
          replay.start()
        }
      }
      else {
        void replay?.stop()
      }
    }, { immediate: true })
  })
})
